import { useEffect } from 'react';
import { useCompassCard } from '@scale/compass-ui/store';
import {
  type ContributorScreeningsContext,
  ContributorScreeningsSearchMode,
} from '@scale/genai-compass-shared/cards/contributor_screenings_adapter';
import { type FilterGroup, isValidFilterGroup } from '@scale/compass-shared/filter';

function useContributorScreeningsAdapterCard(index: number) {
  const { card, updateCardContext, updateCardCanSubmit, error } = useCompassCard(index);
  const context = card.defaultContext as ContributorScreeningsContext;

  const query = context.query;

  const setSearchMode = (searchMode: ContributorScreeningsSearchMode) => {
    updateCardContext({
      ...context,
      searchMode,
    } as ContributorScreeningsContext);
  };

  const setQuery = (query: string) => {
    updateCardContext({
      ...context,
      query,
    } as ContributorScreeningsContext);
  };

  const setContributorScreeningsFilter = (contributorScreeningsFilter: FilterGroup) => {
    updateCardContext({
      ...context,
      contributorScreeningsFilter,
    } as ContributorScreeningsContext);
  };

  // Update canSubmit based on filters
  useEffect(() => {
    let canSubmit = true;

    if (context.searchMode === 'Search') {
      if (!context.query) {
        canSubmit = false;
      }
    } else if (context.searchMode === 'Filter') {
      canSubmit = isValidFilterGroup(context.contributorScreeningsFilter);
    } else {
      canSubmit = false;
    }

    updateCardCanSubmit(canSubmit);
  }, [context.searchMode, context.query, context.contributorScreeningsFilter]);

  return {
    contributorScreeningsFilter: context.contributorScreeningsFilter,
    setContributorScreeningsFilter,
    query,
    setQuery,
    searchMode: context.searchMode,
    setSearchMode,
    hasError: !!error,
  };
}

export default useContributorScreeningsAdapterCard;
